import { lazy, Suspense } from "react"
import type { Id } from "~convex/_generated/dataModel"

const loadComposeModal = () => import("./ComposeModal")

const ComposeModal = lazy(async () => {
	const module = await loadComposeModal()
	return { default: module.ComposeModal }
})

type LazyComposeModalProps = {
	onClose: () => void
	lockedCommunity?: { ticker: string; name: string; mint: string } | null
} & ({ mode: "post" } | { mode: "quote"; quotePostId: Id<"posts"> })

export function preloadComposeModal() {
	loadComposeModal().catch(() => {})
}

export function LazyComposeModal(props: LazyComposeModalProps) {
	return (
		<Suspense fallback={null}>
			<ComposeModal {...props} />
		</Suspense>
	)
}
